import React, { Suspense } from 'react'
import { Canvas } from 'react-three-fiber'
import ErrorBoundary from './ErrorBoundary'
import DevicePermission from './DevicePermission'
import Control from './Contorl'
import Stage from './Stage'
import Ground from './Ground'
import Cloud from './Cloud'
import Light from './Light'
import LoadAnimal from './LoadAnimal'
import Introduction from './Introduction'
import config from './config'

function App() {
	const virticalMin = (0.5 - config.camera.virticalMin / 180) * Math.PI
	const virticalMax = (0.5 + config.camera.virticalMax / 180) * Math.PI

	return (
		<>
			<Canvas
				concurrent
				gl={{ antialias: false }}
				camera={{ fov: 50, position: config.camera.position }}
				onCreated={
					({ gl }) => {
						gl.setClearColor(config.color.sky)
					}
				}
			>
				<Light name="URB/ZOO:照明" />
				<fog
					name="URB/ZOO:霞"
					attach="fog"
					args={[config.color.sky, 4, 20]}
				/>
				<Suspense fallback={null}>
					<Cloud name="URB/ZOO:雲" count="40" />
				</Suspense>
				<Suspense fallback={null}>
					<Ground
						name="URB/ZOO:地面"
						position={[0, -0.1, 0]}
						size={[50, 50]}
						color={config.color.ground}
					/>
				</Suspense>
				<Suspense fallback={null}>
					<Stage name="URB/ZOO:美術館" />
				</Suspense>
				<ErrorBoundary>
					<LoadAnimal name="URB/ZOO:ローダ" />
				</ErrorBoundary>
				<Control
					name="URB/ZOO:コントローラ"
					lookSpeed={config.camera.lookSpeed}
					movementSpeed={config.camera.walkSpeed}
					constrainVertical={true}
					verticalMin={virticalMin}
					verticalMax={virticalMax}
				/>
			</Canvas>
			<Introduction />
			<DevicePermission />
			<div id="fb-root"></div>
			<div className="urb-zoo-social-button">
				<span className="urb-zoo-social-item">
					<div className="fb-like" data-href="https://shinbundobutsuen.com/ohanashikoen/vr/" data-layout="button_count"
						data-action="like" data-size="small" data-show-faces="false" data-share="true" data-kid-directed-site="true">
					</div>
				</span>
				<span className="urb-zoo-social-item">
					<a href="https://twitter.com/share?ref_src=twsrc%5Etfw" className="twitter-share-button"
						data-show-count="false">Tweet</a>
				</span>
				<span className="urb-zoo-social-item">
					<div className="line-it-button" data-lang="ja" data-type="share-b"
						data-url="https://shinbundobutsuen.com/ohanashikoen/vr/"></div>
				</span>
			</div>
		</>
	);
}

export default App;
